import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { ListCell } from '@cbhq/cds-web/cells/ListCell';
import { Icon } from '@cbhq/cds-web/icons/Icon';
import { VStack } from '@cbhq/cds-web/layout';
import { Text } from '@cbhq/cds-web/typography/Text';
import { defineMessages, useIntl } from '@cbhq/i18n';

import { ROUTE_APPROVAL_RULES } from '../utils/constants';

const messages = defineMessages({
  title: {
    id: 'Security.home.title',
    defaultMessage: 'Security',
    description: 'Title for the workspace Security page',
  },
  approvalRulesTitle: {
    id: 'Security.home.approvalRulesTitle',
    defaultMessage: 'Approval rules',
    description: 'Title for the approval rules entry point on the workspace Security page',
  },
  approvalRulesDescription: {
    id: 'Security.home.approvalRulesDescription',
    defaultMessage: 'Require approvals for sensitive actions (eg. transfers, changes)',
    description: 'Description for the approval rules entry point on the workspace Security page',
  },
});

export function SecurityPage() {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();

  const handleApprovalRulesClick = useCallback(() => {
    navigate(ROUTE_APPROVAL_RULES);
  }, [navigate]);

  const approvalRulesTitle = useMemo(
    () => formatMessage(messages.approvalRulesTitle),
    [formatMessage],
  );

  return (
    <VStack gap={4} width="100%" data-testid="security-page">
      <Text as="h1" font="title1">
        {formatMessage(messages.title)}
      </Text>

      <ListCell
        accessory="arrow"
        spacingVariant="condensed"
        media={<Icon name="api" size="s" color="fg" />}
        title={approvalRulesTitle}
        description={formatMessage(messages.approvalRulesDescription)}
        onClick={handleApprovalRulesClick}
        accessibilityLabel={approvalRulesTitle}
        testID="security-approval-rules-entry"
      />
    </VStack>
  );
}
